import React, { Component } from 'react';
import './App.css';


class Title extends Component {
  render() { 
    return (
	<div className="Title">
	{this.props.title}
	</div>
	);
  }
}

class Description extends Component {
  render() { 
    return (
	<div className="Description">
	<div>{this.props.children}</div>
	</div>
	);
  }
}
class DateRange extends Component {
  render() { 
    return (
	<div className="DateRange">
	{this.props.dateRange}
	</div>
	);
  }
}
// eslint-disable-next-line
class Skills extends Component {
  render() { 
    return (
	<div className="Skills">
	<b>Skills:</b> {this.props.skills}
	</div>
	);
  }
}

	//<b>Company:</b> {this.props.company}
class Company extends Component {
  render() { 
    return (
	<div className="Company">
	<b>{this.props.company}</b>
	</div>
	);
  }
}

// Main block that will show the overall job block
	  //<Skills {...this.props} />
class Job extends Component {
  render() { 
    return (
	<div className="Job">
	  <div className="JobRow">
	    <Company {...this.props} />
	    <Title {...this.props} />
	    <DateRange {...this.props} />
	  </div>
	  <div className="JobCol">
	  <Description {...this.props} />
	  </div>
	</div>
	);
  }
}

export default Job;



// WEBPACK FOOTER //
// ./src/Job.js